import { createSlice } from "@reduxjs/toolkit";

const hamburgerSlice = createSlice({
    name: 'hamburger',
    initialState: {
      isOpen: false,
    },
    reducers: {
      toggleHamburger: (state) => {
        state.isOpen = !state.isOpen;
      },
      closeHamburger: (state) => {
        state.isOpen = false;
      },
    },
  });
  export const { toggleHamburger, closeHamburger } = hamburgerSlice.actions;
  export default hamburgerSlice.reducer;